




















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { InstitutionsModule } from '@/store/Settings/InstitutionsModule';
import CreatePaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CreatePaymentOrderRequest';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'PaymentOrderSenderDetails' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    request: CreatePaymentOrderRequest;

    get institutionAddress() {
        return InstitutionsModule.institutionLoggedIn.address;
    }

    get countryOptions() {
        return ListUtils.countryOptions();
    }

}
